import { createServerFn } from "@tanstack/react-start";

import { checkAuth } from "../http";

export const checkAuthFn = createServerFn().handler(async () => {
  const auth = await checkAuth();
  return {
    authenticated: !!auth,
    userId: auth?.payload?.sub,
  };
});

export const refreshAuthFn = createServerFn().handler(async () => {
  const auth = await checkAuth();
  return {
    accessToken: auth?.accessToken,
  };
});
